export default {
  pageTitle: "Expense Budgets",
  pageDescription:
    "Set spending limits per category and monitor your current spend. Get alerts when thresholds are crossed.",
  columnCategory: "Category",
  columnPeriod: "Period",
  columnLimit: "Limit",
  columnSpent: "Current Spend",
  columnPercent: "Usage",
  columnThreshold: "Alert at",
  monthly: "Monthly",
  annual: "Annual",
  createButton: "New Budget",
  createTitle: "Create Expense Budget",
  editTitle: "Edit Expense Budget",
  category: "Category",
  period: "Period",
  amount: "Limit Amount",
  currency: "Currency",
  alertThreshold: "Alert Threshold %",
  loading: "Loading...",
  emptyTitle: "No budgets set",
  emptyMessage: "Set your first budget to track spending against limits.",
  createSuccess: "Budget created successfully",
  updateSuccess: "Budget updated successfully",
  deleteSuccess: "Budget deleted successfully",
  deleteConfirm: "Are you sure you want to delete this budget?",
};
